import { BotConfiguration } from '@feedyou/schema'

import { endpointHelpers } from '../endpointHelpers'
import { RootState } from '../../../reducers'

export const currentBotConfigurationSelector = (state: RootState): BotConfiguration | undefined => {
  return endpointHelpers.getConfigurationForCurrentBot.selectData()(state)?.configuration
}
